import ConfigService from 'src/services/config/config.service';

declare const grecaptcha: any;
export async function RecaptchaToken(): Promise<string> {
    if (grecaptcha) {
        return new Promise<string>(res => {
            grecaptcha.enterprise.ready(() => {
                grecaptcha.enterprise.execute(ConfigService.getConfig().gRecaptcha, { action: 'precatorio_search' })
                    .then((token) => {
                        res(token);
                    });
            });
        });
    }
    else {
        return Promise.reject('Recaptcha not loaded');
    }
}